module.exports = __webpack_public_path__ + "static/olzhas-23184dd497b0c9e195589a77bcd50645.jpeg";